// Heal / clone (§11.8): brush tool, mode, opacity of new spots, spot count and removal.
import { useState } from 'react';
import { Slider } from '../controls/Slider';
import { BrushControls, ToolButton } from './BrushControls';
import { useActive } from './useActive';
import { useUi } from '../../state/ui';
import { useT } from '../../i18n';

export function HealPanel() {
  const t = useT();
  const { settings, update } = useActive();
  const mode = useUi((s) => s.healMode);
  const [opacity, setOpacity] = useState(100);
  const n = settings.heal.length;
  return (
    <div>
      <ToolButton tool="heal" label={t('healTool')} testId="heal-tool" />
      <div role="radiogroup" style={{ display: 'flex', gap: 4, marginBottom: 6 }}>
        {(['heal', 'clone'] as const).map((m) => (
          <button
            key={m}
            role="radio"
            aria-checked={mode === m}
            data-testid={`heal-mode-${m}`}
            onClick={() => useUi.getState().set({ healMode: m })}
            style={mode === m ? { background: 'var(--accent)', color: '#fff' } : undefined}
          >
            {t(m === 'heal' ? 'healModeHeal' : 'healModeClone')}
          </button>
        ))}
      </div>
      <div style={{ fontSize: 12, marginBottom: 6, opacity: 0.8 }}>{t('healHint')}</div>
      <BrushControls flow={false} />
      <Slider
        label="opacity"
        testId="slider-heal-opacity"
        value={opacity}
        min={1}
        max={100}
        step={1}
        defaultValue={100}
        onChange={(v, final) => {
          setOpacity(v);
          // Applies to the most recent spot (new spots start at 100%).
          if (n) update((s) => void (s.heal[s.heal.length - 1]!.opacity = v / 100), final);
        }}
      />
      <div style={{ fontSize: 12, margin: '6px 0' }} data-testid="heal-count">
        {t('healCount', { n })}
      </div>
      <div style={{ display: 'flex', gap: 6 }}>
        <button disabled={!n} data-testid="heal-undo-last" onClick={() => update((s) => void s.heal.pop())}>
          {t('healUndoLast')}
        </button>
        <button disabled={!n} data-testid="heal-clear" onClick={() => update((s) => void (s.heal = []))}>
          {t('healClear')}
        </button>
      </div>
    </div>
  );
}
